import { useEffect, useState } from "react";
import { endOfMonth, format, set, startOfMonth } from "date-fns";
import { useAPIgetPackage } from "../api/api-get-package";
import RemainingPackageList from "./RemainingPackageList";
import RemainingCustomerPackageByBC from "./RemainingCustomerPackageByBC";
import RemainingCustomerPackageFilter from "./RemainingCustomerPackageFilter";

const RemainingCustomerPackageMain = () => {
  const { data, loading, error, filterValue, setFilterValue, fetchData } =
    useAPIgetPackage();

  const [BCList, setBCList] = useState(null);

  useEffect(() => {
    fetchData({});
  }, [filterValue]);

  return (
    <div className="w-full col-center-start gap-4 p-4">
      <RemainingCustomerPackageByBC max={data} onDataReady={setBCList} />
      <RemainingCustomerPackageFilter
        setFilterValue={setFilterValue}
        filterValue={filterValue}
        error={error}
        loading={loading}
        BCList={BCList}
      />
      <RemainingPackageList
        data={data}
        filterValue={filterValue}
        loading={loading}
      />
    </div>
  );
};

export default RemainingCustomerPackageMain;
